import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function useActiveLoyalty(
  websiteId: string,
  {partial = false}: {partial?: boolean} = {}
) {
  const {activeLoyalty, loading, error} = useQuery({
    query: gql`
      query getActiveLoyaltyCheckoutV2($websiteId: ID) {
        activeLoyalty(websiteId: $websiteId) {
          _id
          name
          label
        }
      }
    `,
    variables: {websiteId},
    omit: !websiteId,
    partial
  })

  return {activeLoyalty, loading, error}
}
